import { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { Trash2Icon } from "lucide-react";

export function DeleteSymbolModal({ symbol, product, category, handleRemoveSymbolFromList }) {
  const [open, setOpen] = useState(false);

  const handleRemoveSymbol = () => {
    console.log("Removing Symbol:", symbol, product, category);
    handleRemoveSymbolFromList(symbol, product, category);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-rose-700 rounded-[6px] text-white px-2 h-8 w-8 font-medium hover:bg-rose-500/90">
          <Trash2Icon className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">
            Delete Pledge Plus Symbol
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this symbol ({symbol}) from database?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            className="mt-4 text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={handleRemoveSymbol}
          >
            Confirm Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
